import React, {useEffect, useState} from 'react';
import Logo from './img/404.svg';
import './errorPage404.scss';
import {withRouter} from 'react-router-dom';
import {t} from 'react-switch-lang';

function ErrorPage404({history}) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 200);
    return () => {
      setShow(false);
    };
  }, []);
  return (
    <div
      className={`error-page-container position-relative ${show ? '' : 'hide'}`}
    >
      <div className={`d-inline-block position-absolute info-containter`}>
        <div className="errorCode d-flex justify-content-center align-items-center">
          <img src={Logo} alt="Logo" />
        </div>
        <div className="message-text">
          <span>{t('errorPages.notFound')}</span>
        </div>
        <div className="return-text">
          <button onClick={() => history.go(-2)}>
            {t('errorPages.return')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default withRouter(ErrorPage404);
